import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["loader", "iframe"]

  hideLoader() {
    this.loaderTarget.classList.add("hidden")
  }
}
